import * as tagColor from './CountTag.module.scss';
import { CountTag } from './CountTag';
import { UnorderedListOutlined } from '@ant-design/icons';
import React, { memo } from 'react';
export const PicklistCountTag = memo(({ count }) => React.createElement(CountTag, { color: tagColor.picklistCount, count: count, icon: React.createElement(UnorderedListOutlined, null), tooltip: `This field has ${count} picklist values.`, visible: count > 0 }));
